import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../Table';
import type { PathTraffic } from '../../types/traffic';
interface TopPathsTableProps {
  paths: PathTraffic[];
}
export function TopPathsTable({
  paths
}: TopPathsTableProps) {
  if (paths.length === 0) {
    return <p className="py-10 text-center font-mono text-xs text-muted-foreground" data-id="element-482" data-mp="39o1g0o9e40ri">
        No requested URLs recorded yet
      </p>;
  }
  return <div className="-mx-1 overflow-x-auto px-1" data-id="element-483" data-mp="2c23xiqv0fvfk">
      <Table data-id="element-484" data-mp="2gyazy9o76osr">
        <TableHeader data-id="element-485" data-mp="2gzvtbvys01p1">
          <TableRow data-id="element-486" data-mp="2gzci0y3msbjz">
            <TableHead data-id="element-487" data-mp="2ly70fyxory3k">Requested URL</TableHead>
            <TableHead className="text-right" data-id="element-488" data-mp="2lxe2nngpgixk">Requests</TableHead>
            <TableHead className="text-right" data-id="element-489" data-mp="2qx0d5p55fl2o">Visitors</TableHead>
            <TableHead className="text-right" data-id="element-490" data-mp="2qv78ugi0dcxu">Share</TableHead>
            <TableHead className="whitespace-nowrap text-right" data-id="element-491" data-mp="16ww4apizjjv">Median time on page</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody data-id="element-492" data-mp="695ob4ukqhkx">
          {paths.map(path => <TableRow key={path.path} data-id="element-493" data-mp="27b9wod4cd22m">
              <TableCell className="whitespace-nowrap font-mono text-xs" data-id="element-494" data-mp="27a8kg5bla9jb">{path.path}</TableCell>
              <TableCell className="text-right font-mono text-xs tabular-nums" data-id="element-495" data-mp="22e1fofuxj42y">
                {path.requests.toLocaleString()}
              </TableCell>
              <TableCell className="text-right font-mono text-xs tabular-nums" data-id="element-496" data-mp="1tdcw75mrobio">
                {path.visitors === undefined ? '—' : path.visitors.toLocaleString()}
              </TableCell>
              <TableCell className="text-right font-mono text-xs tabular-nums" data-id="element-497" data-mp="1jm8j6bgnj0qh">
                {Math.round(path.share * 100)}%
              </TableCell>
              <TableCell className="text-right font-mono text-xs tabular-nums" data-id="element-498" data-mp="1elkv9ynpz00h">
                {path.medianTimeOnPage}
              </TableCell>
            </TableRow>)}
        </TableBody>
      </Table>
    </div>;
}